/**
 * @function filterObjectByIncludeList
 * @description Creates a new object containing only the keys specified in the include list
 * @param {Object} [obj={}] - The source object to filter
 * @param {Array<string>} [includeKeys=[]] - Array of keys to include in the result
 * @returns {Object} A new object containing only the specified keys from the original object
 *
 * @example
 * // Returns { name: 'John', age: 30 }
 * filterObjectByIncludeList({ name: 'John', age: 30, city: 'New York' }, ['name', 'age']);
 */
export function filterObjectByIncludeList(obj = {}, includeKeys = []) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (includeKeys.includes(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

/**
 * @function getBrandContext
 * @description Maps brand code to its corresponding brand context
 * @param {string} [brand='anf'] - The brand code to map
 * @returns {string} The corresponding brand context, defaults to 'anf' for unknown brands
 *
 * @example
 * // Returns "anf"
 * getBrandContext('anf');
 *
 * @example
 * // Returns "hol"
 * getBrandContext('gh');
 */
export function getBrandContext(brand = 'anf') {
  return ({
    anf: 'anf',
    kids: 'anf',
    hol: 'hol',
    gh: 'hol',
  })[brand] || 'anf';
}

export function downloadPngFromBase64(base64Data, fileName) {
  // Create a data URI for the PDF
  const pdfDataUri = `data:image/png;base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = pdfDataUri;
  downloadLink.download = `${fileName}.png`;
  downloadLink.click();
  downloadLink.remove();
}
